import { SagaIterator } from 'redux-saga';
import { call, put, takeLatest } from 'redux-saga/effects';

import { GetExtractEncryptionKeyRequest, GetSiteSettingsRequest } from '~src/bootstrap/redux/actions/AppActionTypes';
import { requestFailed } from '~src/bootstrap/redux/actions/RequestFailedAction';
import { Messages } from '~src/codegen/Localize';
import { ISiteSettingsForSiteAdmin } from '~src/settings/types/ISiteSettingsForSiteAdmin';

import { GetExtractEncryptionKeyRequestAction, getExtractEncryptionKeyRequestSucceeded } from '../actions/GetExtractEncryptionKeyRequestAction';
import { GetSiteSettingsRequestAction, siteSettingsRequestSucceeded } from '../actions/SiteSettingsRequestAction';
import { IGetSiteEncryptionKeyResult } from '../models/ExtractEncryptionModels';
import { retrieveSiteEncryptionKey } from '../services/ExtractEncryptionKeyService';
import { getSiteSettings } from '../services/UpdateSiteSettingsService';


export function* handleGetExtractEncryptionKeyRequest(action: GetExtractEncryptionKeyRequestAction) {
    try {
      const encryptionKey: IGetSiteEncryptionKeyResult =  yield call(retrieveSiteEncryptionKey);
      yield put(getExtractEncryptionKeyRequestSucceeded(encryptionKey));
    } catch(e) {
      yield put(requestFailed(e, Messages.errorUnknown()));
    }
  }

  export function* handleGetSiteSettingsRequest(action: GetSiteSettingsRequestAction) {
    try {
      const siteSettings: ISiteSettingsForSiteAdmin =  yield call(getSiteSettings, action.siteId);
      yield put(siteSettingsRequestSucceeded(siteSettings));
    } catch(e) {
      yield put(requestFailed(e, Messages.errorUnknown()));
    }
  }

export function* rootExtractEncryptionSagas(): SagaIterator {
    yield takeLatest(GetExtractEncryptionKeyRequest, handleGetExtractEncryptionKeyRequest);
    yield takeLatest(GetSiteSettingsRequest, handleGetSiteSettingsRequest);
  }